module.exports = __webpack_public_path__ + "img/couples_08_V.4677f2aa.webp";